/** Number/date formatting helpers. Locale follows the active i18n language. */

let _locale = 'sr-RS';

/** Set by the LanguageProvider when the language changes. */
export function setLocale(locale: string): void {
  _locale = locale;
}

export function fmt(n: number | undefined | null): string {
  if (n === undefined || n === null || Number.isNaN(n)) return '0';
  return n.toLocaleString(_locale);
}

/** Safe percentage from a part/whole, rounded, as a number 0–100. */
export function pct(part: number, whole: number): number {
  if (!whole) return 0;
  return Math.round((part / whole) * 100);
}

export function fmtDate(value?: string): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(_locale, { day: '2-digit', month: 'short', year: 'numeric' });
}
